import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";

export function useIsJobInterviewsEnabled() {
  return useCbhFlag(CbhFeatureFlag.ROLLOUT_JOB_INTERVIEWS, {
    defaultValue: false,
  });
}
